import { communityProject, projectRepository } from './community-projects'
import { SEO_ORIGIN } from './company'
import { withLocalePath } from './i18n-utils'

export function projectHead(slug: string, locale: string, paged = false) {
  const project = communityProject(slug)
  if (!project) return { meta: [{ name: 'robots', content: 'noindex,follow' }] }
  const description = locale === 'bs-BA' ? project.bs : project.en
  const title = `${project.name} — Horizon Tech Commons`
  const path = `/community/projects/${project.slug}`
  const url = SEO_ORIGIN + withLocalePath(path, locale)
  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { name: 'robots', content: paged ? 'noindex,follow' : 'index,follow' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ],
    links: [
      { rel: 'canonical', href: url },
      ...['en-US', 'bs-BA'].map((language) => ({
        rel: 'alternate',
        hreflang: language,
        href: SEO_ORIGIN + withLocalePath(path, language),
      })),
    ],
    scripts: [
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'SoftwareSourceCode',
          name: project.name,
          description,
          url,
          codeRepository: projectRepository(project),
          license:
            projectRepository(project) + '/blob/main/' + project.licencePath,
          ...(project.upstream
            ? { isBasedOn: 'https://github.com/' + project.upstream }
            : {}),
        }),
      },
    ],
  }
}
